package com.alpha.showcase.common.repo

actual fun createFtpSourceRepo(): FtpSourceRepo? = null

actual fun createSftpSourceRepo(): SftpSourceRepo? = null

actual fun createSmbSourceRepo(): SmbSourceRepo? = null
